
import DynamicCardForm from "./DynamicCardForm";
import EditableTextAreaModal from "./EditableTextAreaModal.js";
import TabbedDynamicTable from "./TabbedDynamicTable";
import { Row, Col, Checkbox, Form } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import ButtonItem from "./ButtonItem";
import { TAMANO_LETRA_TABLAS_DEFAULT } from "../store/reducers/user";

const { Item: FormItem } = Form;

const VentasForm = ({
  // Header1
  codigo = "",
  // Contenido de las cards fijas, props.children
  datosGeneralesContent,
  // Card opcional que se renderiza justo debajo de "DATOS GENERALES"
  belowDatosGeneralesContent,
  belowDatosGeneralesTitle = "",
  // Permite controlar el tamaño de la columna que envuelve "DATOS GENERALES"
  datosGeneralesCol = { span: 24 },
  datosClienteContent,
  extrasContent,
  doctorContent,
  formaDePagoContent,
  regimenFiscalContent,
  monedaContent,
  datosVentaContent,
  // Permite controlar el tamaño de la columna que envuelve "MONEDA"
  monedaCol = { xs:24, sm:24, md:12, lg:9, xl:8, xxl:7 },
  // Permite controlar el tamaño de las columnas de Cliente y Datos Venta
  datosClienteCol = { xs:24, sm:24, md:12, lg:12, xl:8, xxl:6 },
  datosVentaCol   = { xs:24, sm:24, md:12, lg:12, xl:8, xxl:6 },

  // Visibilidad de cards opcionales
  showDoctor = true,
  showRegimenFiscal = false,
  showMoneda = true,
  showFormaDePago = false,
  // provisional: si true, mueve la card MONEDA de Fila 1 a Fila 2
  monedaEnFila2 = false,

  // Secciones adicionales - TabbedDynamicTable
  tabs = [],
  defaultActiveKey,
  onTabChange,
  isMobile = false,
  formInstance,
  tabBarExtraContent,

  // Secciones adicionales
  observacionesTotalesContent,
  bottomCards = [],

  // Sección de Observaciones y Totales (nueva estructura)
  observacionesConfig,

  // Botones de acción: pasar `null` para ocultarlos explícitamente
  // si no se pasa nada, se renderizarán botones por defecto
  actionButtons = undefined,

  // Total para ajustar ancho dinámicamente
  totalPagar = 0,

  style = {},
  gutter = [12, 12],
}) => {
  const [tableScrollEnabled, setTableScrollEnabled] = useState(false);
  // Tamaño de letra
  const tamanoLetraTablas = useSelector(
    (state) => state.user.tamanoLetraTablas || TAMANO_LETRA_TABLAS_DEFAULT
  );

  const handleScrollToggle = (isEnabled) => {
    setTableScrollEnabled(isEnabled);
  };

  // Determinar si el total es grande (>= 1,000,000)
  const totalEsGrande = totalPagar >= 1000000;
  const anchoCardTotales = totalEsGrande ? 400 : 320;

    return (
    <div
      className="ventas-form-container"
      style={{
        fontSize: "14px",
        width: "100%",
        padding: 15,
        "--tabla-font-size": `${tamanoLetraTablas}px`,
        ...style,
      }}
    >
      {/* ---------- Estilos globales ---------- */}
      <style>
        {`
          .ventas-form-action-buttons button:hover .anticon,
          .ventas-form-action-buttons .ant-btn:hover .anticon {
            color: #ffffff !important; /* Cambia el color del ícono a blanco */
          }
          .ventas-form-container .ant-form-item-label > label {
            font-size: 14px !important;
          }
          .ventas-form-container .ant-input,
          .ventas-form-container .ant-input-number,
          .ventas-form-container .ant-input-number-input,
          .ventas-form-container .ant-select-selection-item,
          .ventas-form-container .ant-select-selection-placeholder,
          .ventas-form-container .ant-picker-input > input {
            font-size: 14px !important;
          }
          .ventas-form-container .ant-form-item {
            font-size: 14px !important;
          }
          .ventas-form-container .ant-select-arrow,
          .ventas-form-container .ant-picker-suffix {
            font-size: 14px !important;
          }

          /* ====== Ajuste de tamaño para labels y contenido de DynamicCardForm ====== */
          .dynamic-card-form .ant-form-item-label > label {
            font-size: 14px !important;
          }
          .dynamic-card-form .ant-form-item-control-input-content,
          .dynamic-card-form .ant-form-item-control {
            font-size: 14px !important;
          }

           /* Estilos para los botones de acción */
          .ventas-form-action-buttons-wrapper {
            border-top: 1px solid #f0f0f0;
            padding-top: 20px;
            margin-top: 20px;
          }

          .ventas-form-action-buttons {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            width: 100%;
            justify-content: flex-end;
          }

          .ventas-form-action-buttons button,
          .ventas-form-action-buttons .ant-btn {
            width: 100% !important;
            height: 30px !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            border-radius: 0 !important;
            transition: all 0.22s ease !important;
            border: none !important;
            border-bottom-width: 3.5px !important;
            border-bottom-style: solid !important;
            padding-bottom: 3px !important;
          }

          .ventas-form-action-buttons button span,
          .ventas-form-action-buttons .ant-btn span {
            font-size: 12px !important;
            font-weight: 550 !important;
          }

          .ventas-form-action-buttons button:hover,
          .ventas-form-action-buttons .ant-btn:hover {
            transform: translateY(-1px) !important;
            border-radius: 6px !important;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
            border-bottom-width: 0.1px !important;
          }

          @media (max-width: 768px) {
            .ventas-form-action-buttons > * {
              flex: 1 1 auto;
              min-width: 140px;
              max-width: 100%;
            }
            .ventas-form-action-buttons {
              gap: 8px;
            }
          }

          /* Apila observaciones y totales en pantallas md */
          @media (max-width: 991px) {
            .ventas-obs-totales-row {
              flex-direction: column !important;
            }
            .ventas-obs-totales-row > .ant-col {
              max-width: 100% !important;
              flex: 0 0 100% !important;
              width: 100% !important;
              margin-bottom: 12px;
            }
          }
        `}
      </style>
        {/* Header */}
        {codigo && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
              paddingBottom: 12,
              borderBottom: "1px solid #f0f0f0",
              width: "100%",
            }}
          >
            <h1
              style={{
                margin: 0,
                fontSize: "13px",
                fontWeight: 600,
                color: "#333",
              }}
            >
              {codigo}
            </h1>
          </div>
        )}


        <div style={{ width: "100%", marginTop: 15, marginBottom: 15 }}>
          {/* FILA 1: Datos Generales | columna derecha: Moneda (arriba) + Régimen Fiscal (abajo) */}
          <Row gutter={gutter}>
            {/* Datos Generales */}
            {datosGeneralesContent && (
              <Col {...datosGeneralesCol}>
                <DynamicCardForm title="DATOS GENERALES" span={24} noMargin>
                  {datosGeneralesContent}
                </DynamicCardForm>
                {belowDatosGeneralesContent && (
                  <DynamicCardForm
                    title={belowDatosGeneralesTitle}
                    span={24}
                    noMargin
                    style={{ marginTop: gutter?.[1] ?? 12 }}
                  >
                    {belowDatosGeneralesContent}
                  </DynamicCardForm>
                )}
              </Col>
            )}
            {/* Columna derecha: Moneda arriba, Régimen Fiscal abajo */}
            {(showMoneda && monedaContent && !monedaEnFila2) || (showRegimenFiscal && regimenFiscalContent) ? (
              <Col {...monedaCol}>
                {/* Moneda */}
                {showMoneda && monedaContent && !monedaEnFila2 && (
                  <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const monedaId = getFieldValue('monedaId');
                      const esPesos = monedaId === '60c7e4396465ad440c41c15a';
                      if (esPesos && getFieldValue('tipoDeCambio') !== 1) {
                        setTimeout(() => setFieldsValue({ tipoDeCambio: 1 }), 0);
                      }
                      return (
                        <DynamicCardForm title="MONEDA" span={24} marginBottom={showRegimenFiscal && regimenFiscalContent ? (gutter?.[1] ?? 12) : 0}>
                          {React.Children.map(monedaContent, (child) => {
                            if (!child) return null;
                            if (child.props && child.props.name === 'tipoDeCambio' && esPesos) return null;
                            return child;
                          })}
                        </DynamicCardForm>
                      );
                    }}
                  </FormItem>
                )}
                {/* Régimen Fiscal */}
                {showRegimenFiscal && regimenFiscalContent && (
                  <DynamicCardForm title="RÉGIMEN FISCAL EMISOR" span={24} noMargin>
                    {regimenFiscalContent}
                  </DynamicCardForm>
                )}
              </Col>
            ) : null}
          </Row>

          {/* FILA 2: Cliente, Doctor, Forma de Pago, Datos Venta */}
          {(() => {
            const doctorEnFila3 = showDoctor && doctorContent && showRegimenFiscal && regimenFiscalContent;

            return (
              <>
              <Row gutter={gutter} style={{ marginTop: 8 }}>

            {/* Forma de Pago */}
            {showFormaDePago && formaDePagoContent && (
              <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} style={{ display: 'flex' }}>
                <DynamicCardForm title="FORMA DE PAGO" span={24} noMargin>
                  {formaDePagoContent}
                </DynamicCardForm>
              </Col>
            )}

            {/* Datos Venta */}
            {datosVentaContent && (
              <Col {...datosVentaCol} style={{ display: 'flex' }}>
                  <DynamicCardForm title="DATOS VENTA" span={24} noMargin style={{ minHeight: 180 }}>
                  {datosVentaContent}
                </DynamicCardForm>
              </Col>
            )}
            
            {/* Datos del Cliente */}
            {datosClienteContent && (
              <Col {...datosClienteCol} style={{ display: 'flex' }}>
                <DynamicCardForm title="DATOS DEL CLIENTE" span={24} noMargin>
                  {datosClienteContent}
                </DynamicCardForm>
              </Col>
            )}

            {/* Doctor - en fila 2 solo si hay 3 o menos cards */}
            {showDoctor && doctorContent && !doctorEnFila3 && (
              <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} style={{ display: 'flex' }}>
                <DynamicCardForm title="EQUIPO MÉDICO" span={24} noMargin style={{ height: '100%', flex: 1 }}>
                  {doctorContent}
                </DynamicCardForm>
              </Col>
            )}

            {/* Moneda (Fila 2 - provisional, solo cuando monedaEnFila2=true) */}
            {showMoneda && monedaContent && monedaEnFila2 && (
              <Col {...monedaCol} style={{ display: 'flex' }}>
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                  {({ getFieldValue, setFieldsValue }) => {
                    const monedaId = getFieldValue('monedaId');
                    const esPesos = monedaId === '60c7e4396465ad440c41c15a';
                    if (esPesos && getFieldValue('tipoDeCambio') !== 1) {
                      setTimeout(() => setFieldsValue({ tipoDeCambio: 1 }), 0);
                    }
                    return (
                      <DynamicCardForm title="MONEDA" span={24} noMargin>
                        {React.Children.map(monedaContent, (child) => {
                          if (!child) return null;
                          if (child.props && child.props.name === 'tipoDeCambio' && esPesos) return null;
                          return child;
                        })}
                      </DynamicCardForm>
                    );
                  }}
                </FormItem>
              </Col>
            )}

            {/* Extras */}
            {extrasContent && (
              <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} style={{ display: 'flex' }}>
                <DynamicCardForm title="EXTRAS" span={24} noMargin>
                  {extrasContent}
                </DynamicCardForm>
              </Col>
            )}


          </Row>

          {/* FILA 3: Doctor - solo cuando hay 4 cards en fila 2 */}
          {showDoctor && doctorContent && doctorEnFila3 && (
            <Row gutter={gutter} style={{ marginTop: 8 }}>
              <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} style={{ display: 'flex' }}>
                <DynamicCardForm title="EQUIPO MÉDICO" span={24} noMargin style={{ height: '100%', flex: 1 }}>
                  {doctorContent}
                </DynamicCardForm>
              </Col>
            </Row>
          )}
              </>
            );
          })()}
        </div>

       {/* Tabla (TabbedDynamicTable) */}
        {tabs.length > 0 && (
          <div style={{ 
            marginTop: '1.875rem'
          }}>
            <TabbedDynamicTable
              tabs={tabs}
              defaultActiveKey={defaultActiveKey}
              onTabChange={onTabChange}
              isMobile={isMobile}
              formInstance={formInstance}
              tabBarExtraContent={tabBarExtraContent}
              onScrollToggle={handleScrollToggle}
              tableClassName="tabla-insumos-venta tabla-compacta"
            />
          </div>
        )}

        {/* Observaciones y Totales */}
        {observacionesTotalesContent && (
          <div style={{ 
            marginTop: tableScrollEnabled ? 15 : 50,
            transition: 'margin-top 0.3s ease'
          }}>
            {observacionesTotalesContent}
          </div>
        )}

        {/* Observaciones y Totales */}
        {observacionesTotalesContent && (
          <div style={{ 
            marginTop: tableScrollEnabled ? '1rem' : '3.125rem',
            transition: 'margin-top 0.3s ease'
          }}>
            {observacionesTotalesContent}
          </div>
        )}

        {/* Observaciones y Totales */}
        {observacionesConfig && (() => {
          const hasObservaciones =
            observacionesConfig.observaciones?.value?.trim() || 
            observacionesConfig.observaciones2?.value?.trim();

          const hasCamposFechas = Boolean(observacionesConfig.camposFechas);
          const hasCheckboxes = observacionesConfig.checkboxes?.length > 0;
          const observacionesLength =
            (observacionesConfig.observaciones?.value?.length || 0) +
            (observacionesConfig.observaciones2?.value?.length || 0);
          const isObservacionesLarge = observacionesLength >= 120;

          return (
            <Row
              gutter={12}
              className="ventas-obs-totales-row"
              style={{
                marginTop: tableScrollEnabled ? '1rem' : '3.125rem',
                transition: 'margin-top 0.3s ease'
              }}
              justify={isMobile ? "start" : "end"}
              align="top"
            >
              {/* Card Observaciones */}
              <Col
                xs={24}
                sm={24}
                md={isMobile ? 24 : "auto"}
                lg={isMobile ? 24 : "auto"}
                flex={isMobile ? undefined : "0 0 auto"}
                style={{
                  maxWidth: isMobile 
                    ? "100%" 
                    : (hasObservaciones ? `calc(100% - ${anchoCardTotales + 20}px)` : "auto"),
                  transition: "max-width 0.35s ease, transform 0.35s ease",
                  marginBottom: isMobile ? 12 : 0,
                }}
              >
                <DynamicCardForm span={24} noMargin>
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "flex-start",
                      flexDirection: isMobile ? "column" : "row",
                      flexWrap: isMobile ? "nowrap" : "wrap",
                      transition: "all 0.35s ease",
                    }}
                  >
                    {/* Observaciones */}
                    <div style={{
                      minWidth: isMobile ? "100%" : 200,
                      width: isMobile ? "100%" : "auto"
                    }}>
                      {observacionesConfig.observaciones && (
                        <FormItem name="observaciones" noStyle>
                          <EditableTextAreaModal
                            label="Observaciones"
                            value={observacionesConfig.observaciones.value}
                            onSave={observacionesConfig.observaciones.onSave}
                            disabled={observacionesConfig.observaciones.disabled}
                            rows={4}
                          />
                        </FormItem>
                      )}

                      {observacionesConfig.observaciones2 && (
                        <FormItem name="observaciones2" noStyle>
                          <EditableTextAreaModal
                            label="Observaciones Internas"
                            value={observacionesConfig.observaciones2.value}
                            tooltip="Estas observaciones no se imprimirán en la venta."
                            onSave={observacionesConfig.observaciones2.onSave}
                            disabled={observacionesConfig.observaciones2.disabled}
                            rows={4}
                          />
                        </FormItem>
                      )}
                    </div>

                    {/* Checkboxes */}
                    {hasCheckboxes && (
                      <div
                        style={{ 
                          display: "flex",
                          flexDirection: isMobile ? "column" : (isObservacionesLarge ? "row" : "column"),
                          gap: isMobile ? 8 : (isObservacionesLarge ? 16 : 8),
                          alignItems: isMobile ? "flex-start" : (isObservacionesLarge ? "center" : "flex-start"),
                          minWidth: isMobile ? "100%" : (isObservacionesLarge ? "auto" : 180),
                          width: isMobile ? "100%" : "auto",
                          marginTop: isMobile ? 12 : (!isObservacionesLarge ? 12 : 0),
                          transition: "all 0.25s ease",
                        }}
                      > {/*Contenedor de checkboxes*/}
                        {observacionesConfig.checkboxes.map((checkbox, index) => (
                          <FormItem
                            key={index}
                            name={checkbox.name}
                            valuePropName="checked"
                            style={{
                              marginBottom: 0,
                              whiteSpace: "nowrap",
                            }}
                          >
                          <Checkbox onChange={checkbox.onChange} disabled={checkbox.disabled}>
                              <span style={{ marginLeft: 6, fontSize: 12 }}>
                                {checkbox.label}
                              </span>
                            </Checkbox>
                          </FormItem>
                        ))}
                      </div>
                    )}
                    
                    {/* Fechas */}
                    {hasCamposFechas && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: isMobile ? "column" : (isObservacionesLarge ? "row" : "column"),
                          gap: isMobile ? 8 : (isObservacionesLarge ? 16 : 8),
                          alignItems: isMobile ? "flex-start" : (isObservacionesLarge ? "center" : "flex-start"),
                          minWidth: isMobile ? "100%" : (isObservacionesLarge ? "auto" : 180),
                          width: isMobile ? "100%" : "auto",
                          marginTop: isMobile ? 12 : (!isObservacionesLarge ? 12 : 0),
                          transition: "all 0.25s ease",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {observacionesConfig.camposFechas}
                      </div>
                    )}
                  </div>
                </DynamicCardForm>
              </Col>

              {/* Card Totales */}
              <Col 
                xs={24}
                sm={24}
                md={isMobile ? 24 : "auto"}
                lg={isMobile ? 24 : "auto"}
                flex={isMobile ? undefined : `0 0 ${anchoCardTotales}px`}
                style={{
                  minWidth: isMobile ? "100%" : undefined,
                }}
              >
                <div
                  style={{
                    background: "white",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                    borderLeft: "4px solid #FF6A0D",
                    padding: "8px",
                  }}
                >
                  {observacionesConfig.totales}
                </div>
              </Col>
            </Row>
          );
        })()}

        {/* Cards inferiores */}
        {bottomCards.length > 0 && (
          <Row gutter={gutter} style={{ marginTop: 15 }}>
            {bottomCards.map((card, index) => {
              if (!card.title) {
                return (
                  <div
                    key={`bottom-content-${index}`}
                    style={{ width: "100%" }}
                  >
                    {card.content}
                  </div>
                );
              }

              return (
                <DynamicCardForm
                  key={`bottom-card-${index}`}
                  title={card.title}
                  span={card.span || 24}
                  xs={card.xs || 24}
                  sm={card.sm || 24}
                  lg={card.lg || card.span || 24}
                  xl={card.xl || card.span || 24}
                  style={card.style}
                  bodyStyle={card.bodyStyle}
                  noPadding={card.noPadding}
                  noMargin={card.noMargin}
                >
                  {card.content}
                </DynamicCardForm>
              );
            })}
          </Row>
        )}
        {/* Botones de Acción parte del Footer en vista */}
        {actionButtons !== null && (
          <div className="ventas-form-action-buttons-wrapper">
            <div className="ventas-form-action-buttons">
              {actionButtons ? (
                actionButtons
              ) : (
                <>
                  <ButtonItem onClick={() => {
                    try {
                      if (formInstance && formInstance.resetFields) formInstance.resetFields();
                    } catch (e) {}
                  }}>
                    Cancelar
                  </ButtonItem>
                  <ButtonItem type="primary" htmlType="submit">
                    Guardar
                  </ButtonItem>
                </>
              )}
            </div>
          </div>
        )}
      </div>
  );
};

export default VentasForm;
